// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

/* Add styles for main content spacing */
#root {
  padding-top: 70px; /* Same as navbar height */
  /* min-height: calc(100vh - 70px); */
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar-brand img {
  height: 30px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.navbar-brand img:hover {
  transform: scale(1.05);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.nav-button {
  font-family: "Syne", sans-serif;
  font-size: 1rem;
  padding: 0.5rem 1.2rem;
  border-radius: 12px;
  border: 2px solid #6616cd;
  background-color: white;
  color: #6616cd;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-button:hover {
  background-color: #6616cd;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);
}

.nav-button svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
  position: relative;
}

.hamburger-line {
  width: 100%;
  height: 2px;
  background-color: #6616cd;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.hamburger-line.open:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger-line.open:nth-child(2) {
  opacity: 0;
}

.hamburger-line.open:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

@media screen and (max-width: 768px) {
  .navbar {
    padding: 0 1rem;
  }

  .hamburger-menu {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 70px;
    right: -100%;
    width: 100%;
    height: calc(100vh - 70px);
    background: rgba(255, 255, 255, 0.98);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    flex-direction: column;
    padding: 2rem;
    transition: right 0.3s ease;
    gap: 2rem;
    z-index: 999;
  }

  .nav-links.open {
    right: 0;
  }

  .nav-button {
    width: 100%;
    justify-content: center;
    padding: 1rem;
    font-size: 1.1rem;
  }

  .nav-button svg {
    width: 24px;
    height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yCAAyC;EACzC,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 70px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n/* Add styles for main content spacing */\n#root {\n  padding-top: 70px; /* Same as navbar height */\n  /* min-height: calc(100vh - 70px); */\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n}\n\n.navbar-brand img {\n  height: 30px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.navbar-brand img:hover {\n  transform: scale(1.05);\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.nav-button {\n  font-family: \"Syne\", sans-serif;\n  font-size: 1rem;\n  padding: 0.5rem 1.2rem;\n  border-radius: 12px;\n  border: 2px solid #6616cd;\n  background-color: white;\n  color: #6616cd;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.nav-button:hover {\n  background-color: #6616cd;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);\n}\n\n.nav-button svg {\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n}\n\n.hamburger-menu {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 24px;\n  height: 18px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1001;\n  position: relative;\n}\n\n.hamburger-line {\n  width: 100%;\n  height: 2px;\n  background-color: #6616cd;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n}\n\n.hamburger-line.open:nth-child(1) {\n  transform: translateY(8px) rotate(45deg);\n}\n\n.hamburger-line.open:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-line.open:nth-child(3) {\n  transform: translateY(-8px) rotate(-45deg);\n}\n\n@media screen and (max-width: 768px) {\n  .navbar {\n    padding: 0 1rem;\n  }\n\n  .hamburger-menu {\n    display: flex;\n  }\n\n  .nav-links {\n    position: fixed;\n    top: 70px;\n    right: -100%;\n    width: 100%;\n    height: calc(100vh - 70px);\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(10px);\n    flex-direction: column;\n    padding: 2rem;\n    transition: right 0.3s ease;\n    gap: 2rem;\n    z-index: 999;\n  }\n\n  .nav-links.open {\n    right: 0;\n  }\n\n  .nav-button {\n    width: 100%;\n    justify-content: center;\n    padding: 1rem;\n    font-size: 1.1rem;\n  }\n\n  .nav-button svg {\n    width: 24px;\n    height: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
